import { Icon, SummaryCollapse, Typography } from "@kyan/ui";
import React from "react";

import { Divider } from "#/components/Divider/Divider";
import { useBridgeState } from "#/store/app/equityModal/bridgeState";
import { useShowBridgeHistory } from "#/store/app/equityModal/showBridgeHistory";

import { BridgeHistoryItem } from "./components/BridgeHistoryItem";

export const BridgeHistory: React.FC = () => {
  const { pendingTransactions, settledTransactions } = useBridgeState();
  const { setShowBridgeHistory } = useShowBridgeHistory();

  return (
    <div className="overflow-auto">
      <Typography
        medium
        grotesk
        primary
        element="h2"
        className="mb-2 flex w-full items-center gap-2 text-left"
      >
        <Icon
          size="sm"
          name="caret-up"
          hoverEffect="square"
          className="grid size-8 -rotate-90 place-items-center"
          onClick={() => setShowBridgeHistory(false)}
        />
        Bridge Transactions
      </Typography>
      <div>
        <div className="flex flex-col gap-4">
          {pendingTransactions.map(({ requestHash }) => (
            <BridgeHistoryItem
              requestHash={requestHash}
              key={`pending-${requestHash}`}
            />
          ))}
        </div>
        <Divider className="mt-4" />
        {settledTransactions.length > 0 && (
          <SummaryCollapse isOpen variant="minimal" title="Recent Transactions">
            <div className="flex flex-col gap-4">
              {settledTransactions
                .slice(-3)
                .reverse()
                .map(({ requestHash }) => (
                  <BridgeHistoryItem
                    key={requestHash}
                    requestHash={requestHash}
                  />
                ))}
            </div>
          </SummaryCollapse>
        )}
      </div>
    </div>
  );
};
